import store from "../index";
import {
  SET_PENDING_ACTION,
  SET_MODIFIED_TIME,
  SET_EXECUTE_PENDING_ACTION,
  SET_PROCEDURE_ID,
} from "./constants";

/**
 * Sets the pending action for the procedure detail page
 * @param {(
 * 'ProcedureFilesEdit'|
 * 'ProcedureFilesCoverSheet'|
 * 'ProcedureFilesApplyForJB'|
 * 'ProcedureFilesTLReview'|
 * 'SupportingFilesEdit'|
 * 'ProcedureInfoEdit'|
 * 'SharedTasksEdit'|
 * null)} payload - The type of pending action
 * @returns {Object} Action object with type and payload
 */
export const setPendingAction = (payload: any) => {
  return {
    type: SET_PENDING_ACTION,
    payload,
  };
};

export const setModifiedTime = (payload: any) => {
  return {
    type: SET_MODIFIED_TIME,
    payload,
  };
};

export const setProcedureId = (payload: any) => {
  return {
    type: SET_PROCEDURE_ID,
    payload,
  };
};

/**
 * Sets the checking latest info status
 * @param {boolean} payload - Whether currently checking latest procedure info
 * @returns {Object} Action object with type and payload
 */
export const setExecutePendingAction = (payload: any) => {
  return {
    type: SET_EXECUTE_PENDING_ACTION,
    payload,
  };
};

export const getPendingAction = () => {
  const {
    // @ts-ignore
    procedureDetailPage: { pendingAction },
  } = store.getState();
  return pendingAction;
};

export const isExecutePendingAction = () => {
  const {
    // @ts-ignore
    procedureDetailPage: { isExecutePendingAction },
  } = store.getState();
  return isExecutePendingAction;
};
